import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const OnboardingModal = ({inputValue,toggle,btnText2,btnText1,btnClick1,btnClick2}) => {
  const [modal, setModal] = useState(false);


  //const toggle = () => setModal(!modal);
  console.log(toggle,"toggle");
  return (
    <>
      {inputValue && (
        <div className='invite-modal'>
        <div className='content'>
          <h2 className='heading'>Share this link to invite your team </h2>
            <p>Teammates can use this link to sign up and join your team. (Expires in 72 hours):</p>
            <div className='mb-3'>
              <input type="text" className='input' placeholder="https://play.gameapart.com/gam..." />
            </div>
            <div className='mb-3'>
              <button className='copylink' onClick={btnClick1} >Copy Link</button>
            </div>
            <div className='mb-3'>
              <button className='sharelink' onClick={btnClick2} >Share Link</button>
            </div>
            <div className='mb-3' onClick={toggle}>
              <button className='close'>Close</button>
            </div>
        </div>
      </div>
      )}
      {/* <div className='invite-modal'>
        <Modal isOpen={modal} toggle={toggle} className='invite-modal' style={{bottom: 0, overflowY: 'hidden'}}>
          <ModalBody>
            <h2 className='heading'>Share this link to invite your team </h2>
            <p>Teammates can use this link to sign up and join your team. (Expires in 72 hours):</p>
            <div className='mb-3'>
              <input type="text" className='input' placeholder="https://play.gameapart.com/gam..." />
            </div>
            <div className='mb-3'>
              <button className='copylink'>Copy Link</button>
            </div>
            <div className='mb-3'>
              <button className='sharelink'>Share Link</button>
            </div>
            <div className='mb-3' onClick={toggle}>
              <button className='close'>Close</button>
            </div>
          </ModalBody>
        </Modal>
      </div> */}
    </>
  )
}

export default OnboardingModal
